export default "__VITE_PUBLIC_ASSET__cdde3f84__"